import React from 'react'
import TextBox from '../TextBox.js'
import SexSelect from '../Inputs/SexSelect.js'
import AgeGroupSelect from '../Inputs/AgeGroupSelect.js'

export default function FormPage1(props) {

    const errorStyleCheckbox = {
        outline: (!props.formData.consentCheck && (props.formData.error.consentCheck == true)) ?
            "2px solid #FD625E" :
            "0px",
        outlineOffset: "-2px"
    }

    return (
        <form className="Form" >
            <div className="Form--inputs-container">
                <div className="Form--inputs-section1">
                    <TextBox
                        label="Nickname"
                        name="nickname"
                        value={props.formData.nickname}
                        onChange={props.handleChange}
                        placeholder="e.g. John"
                        errorMessage="Please enter a nickname."
                        errorBoolean={props.formData.error.nickname}
                    />
                    <TextBox
                        label="Email"
                        name="email"
                        value={props.formData.email}
                        onChange={props.handleChange}
                        placeholder="e.g. kizabo@gmail.com"
                        errorMessage="Please enter a valid email."
                        errorBoolean={props.formData.error.email}
                    />
                </div>
                <h4 className="Form--instructions Form--instructions-page1">In order to improve our AI system, we kindly ask you to fill the following questions. We will keep this information anonymous.</h4>

                <TextBox
                    label="Country"
                    name="country"
                    value={props.formData.country}
                    onChange={props.handleChange}
                    placeholder="e.g. Philippines"
                    errorMessage="Please enter a valid country."
                    errorBoolean={props.formData.error.country}
                />
                <div className="Form--inputs-section2">
                    <SexSelect
                        label="Gender"
                        name="sex"
                        selectSexData={props.selectSexData}
                        handleSelectChange={props.handleSelectSexChange}
                        errorMessage="This is a required field."
                        errorBoolean={props.formData.error.sexData}
                    />
                    <AgeGroupSelect
                        label="Age Group"
                        name="agegroup"
                        selectAgeGroupData={props.selectAgeGroupData}
                        handleSelectChange={props.handleSelectAgeGroupChange}
                        errorMessage="This is a required field."
                        errorBoolean={props.formData.error.ageGroupData}
                    />
                </div>
                <div className="Form--inputs-section3">

                </div>
                <div className="Form--consent-section">
                    <input
                        className="Form--consent-checkbox"
                        name="consentCheck"
                        type="checkbox"
                        checked={props.formData.consentCheck}
                        onChange={props.handleChange}
                        style={errorStyleCheckbox}
                    />
                    <h4 className="Form--instructions">I consent to the collection and storage of my email and test answers. My results will be sent to my email in accordance with the <a href="https://kizabo.com/live-privacy-policy" target="_top">Privacy Policy</a>.</h4>
                </div>
                {/*<h3 className="Form--instructions">In order to improve our AI system, we kindly ask you to fill the following questions. We will keep this information anonymous.</h3>*/}
            </div>
        </form>
    )
}